import React from 'react';
import PropTypes from 'prop-types';
import debug from 'debug';
import moment from 'moment';
import {Image, DescriptiveText, Column, Row} from '../../../shared';
import {openDocument} from '../../../shared/utils/utils';

const log = debug('circleblack:investor:components:insights:Insight');

const Insight = ({
  article,
  textMargin,
  minW,
  minH,
  width,
  fontSize = '12px',
  font = 'ProximaSemibold',
  imgWidth,
  isRecent,
  height,
}) => {
  log('rendering');

  const formattedDistributionDate = article.distributionDate ? moment(article.distributionDate, 'YYYY-MM-DD')
    .format('M/D/YY') : null;
  const handleClick = doc => openDocument(doc, null, false, true);

  return (
    <Column
      maxHeight={'fill'}
      height={height}
      width={width}
      overflow={'hidden'}
      justifySubColumn="middle"
      margin={'10px'}
      action={() => handleClick(article)}
    >
      <Row layout={{grow: 1}}
           alignItems={'middle'}
           alignSubRow={'middle'}
           margin={isRecent ? '30px 10px 10px 10px' : '10px'}
           width={imgWidth || '80%'}>
        <Image
          src={article.thumbnail}
          maxHeight="fill"
          maxWidth="fill"
          minHeight={minH}
          minWidth={minW}
          width={'fill'}
        />
      </Row>
      <DescriptiveText
        margin={textMargin}
        fontSize={fontSize}
        font={font}
        ellipsisOverflow={{
          popoverContent: article.title,
          popoverPlacement: 'top',
        }}
        textOverflow="ellipsis"
      >
        {article.title}
      </DescriptiveText>
      {formattedDistributionDate && <DescriptiveText
        margin={'5px'}
        fontSize="9px"
        font="ProximaLight"
        width="fit-content"
        layout={{align: 'center'}}
      >
        {formattedDistributionDate}
      </DescriptiveText>}
    </Column>
  );
};

export default Insight;

Insight.propTypes = {
  /**
   * the Insight article to display
   */
  article: PropTypes.shape({
    title: PropTypes.string.isRequired,
    thumbnail: PropTypes.string.isRequired,
    fileFormat: PropTypes.string.isRequired,
    distributionDate: PropTypes.string.isRequired,
  }),
  /**
   * action to execute on click
   */
  action: PropTypes.func,
  /**
   * margin to apply to the title text
   */
  textMargin: PropTypes.string,
  /**
   * min width of the image only
   */
  minW: PropTypes.string,
  /**
   * min height of the image only
   */
  minH: PropTypes.string,
  /**
   * width
   */
  width: PropTypes.string,
  /**
   * height
   */
  height: PropTypes.string,
  /**
   * font size of the title text
   */
  fontSize: PropTypes.string,
  /**
   * font of the title text
   */
  font: PropTypes.string,
  /**
   * width of Insight thumbnail image
   */
  imgWidth: PropTypes.string,
  /**
   * if Article is Recent
   */
  isRecent: PropTypes.bool,
};
